export const API_KEY = 'AIzaSyBAs5cVHyY6iu2_jE_8WjhZqefXQjcZCJA';

export default API_KEY;
